var map = {
	"./cd-dublu-craciun.jpg": "c5fd",
	"./cd-hora-staccato.jpg": "3102",
	"./cd-madrigal-ave-maria.jpg": "9018",
	"./cd-madrigal-de-craciun.jpg": "8fde",
	"./cd-madrigal-for-christmas.jpg": "9b97",
	"./cd-saptamana-patimilor.jpg": "0835",
	"./christmas-with-madrigal.jpg": "bc15",
	"./cm-rezistenta-prin-colind-2.jpg": "6c79",
	"./cm-rezistenta-prin-colind.jpg": "8026",
	"./cm-turneele-in-sua-2.jpg": "817b",
	"./cm-turneele-in-sua.jpg": "025f",
	"./collection-edition-i.jpg": "052c",
	"./collection-edition-ii.jpg": "864c",
	"./concert-extraordinar-de-craciun.jpg": "84d38",
	"./contemporary-music.jpeg": "98ac",
	"./dvd-pe-drumul-craciunului.jpg": "82ea",
	"./expozitie-de-arta-fotografica.jpg": "a602",
	"./marea-carte-a-madrigalului-2.jpg": "6325",
	"./marea-carte-a-madrigalului.jpg": "d2bb4",
	"./noapte-de-decembrie-madrigal.jpg": "547a",
	"./revista-madrigal-01.jpg": "4c50",
	"./revista-madrigal-02-sold-out.jpg": "bddf",
	"./revista-madrigal-02.jpg": "1b5a",
	"./revista-madrigal-03.jpg": "e607",
	"./revista-madrigal-04.jpg": "5fe3",
	"./revista-madrigal-05.jpg": "9769",
	"./romanian-choral-jewels.jpeg": "ebd5",
	"./vinil-dublu-madrigal-de-craciun.jpg": "f0c0",
	"./vinil-pe-drumul-craciunului.jpg": "11e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4965";